<script setup>
import Card from '@/Components/Card/Card.vue';
import RdapDetail from '@/Pages/HeaderAnalysis/Partials/RdapDetail.vue';
import GeoDetail from '@/Pages/HeaderAnalysis/Partials/GeoDetail.vue';
import PropertyListItem from '@/Pages/HeaderAnalysis/Partials/PropertyListItem.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps({
  hop: Object
});

const hopHasRdapOrGeo = (hop) =>
  hop.from?.rdap || hop.from?.geo || hop.by?.rdap || hop.by?.geo;

const translateRouting = (routing) => {
  switch (routing.toLowerCase()) {
    case 'private':
      return t('header_analysis.partials.email_hop_detail.private');
    case 'public':
      return t('header_analysis.partials.email_hop_detail.public');
    default:
      return t('header_analysis.partials.email_hop_detail.unknown');
  }
};
</script>

<template>
  <Card class="bg-white-500!" :pad-bottom="true">
    <div class="flex flex-col gap-1">
      <PropertyListItem
        :title="$t('header_analysis.partials.email_hop_detail.sender')"
        :value="hop.from.name"
        title-class-width="w-1/6"
      />
      <PropertyListItem
        :title="$t('header_analysis.partials.email_hop_detail.sender_comments')"
        :value="hop.from.comments"
        :array-as-column="true"
        title-class-width="w-1/6"
      />
      <PropertyListItem
        :title="$t('header_analysis.partials.email_hop_detail.receiver')"
        :value="hop.by.name"
        title-class-width="w-1/6"
      />
      <PropertyListItem
        :title="
          $t('header_analysis.partials.email_hop_detail.receiver_comments')
        "
        :value="hop.by.comments"
        :array-as-column="true"
        title-class-width="w-1/6"
      />
      <PropertyListItem
        v-if="hop.id"
        :title="$t('header_analysis.partials.email_hop_detail.receiver_id')"
        :value="hop.id"
        title-class-width="w-1/6"
      />
      <PropertyListItem
        v-if="hop.with"
        :title="$t('header_analysis.partials.email_hop_detail.with_protocol')"
        :value="hop.with"
        title-class-width="w-1/6"
      />
      <PropertyListItem
        v-if="hop.via"
        :title="$t('header_analysis.partials.email_hop_detail.via_mechanism')"
        :value="hop.via"
        title-class-width="w-1/6"
      />
      <PropertyListItem
        :title="$t('header_analysis.partials.email_hop_detail.routing')"
        :value="translateRouting(hop.routing)"
        title-class-width="w-1/6"
        :value-class="['capitalize']"
      />
    </div>

    <div
      v-if="hopHasRdapOrGeo(hop)"
      class="mt-6 flex shrink-0 flex-col gap-6 md:flex-row"
    >
      <Card class="bg-grey-500/10! md:w-1/2">
        <RdapDetail :rdap="hop.from.rdap" context-title="Sending" />
        <GeoDetail :geo="hop.from.geo" class="mt-6" />
      </Card>
      <Card class="bg-grey-500/10! md:w-1/2">
        <RdapDetail :rdap="hop.by.rdap" context-title="Receiving" />
        <GeoDetail :geo="hop.by.geo" class="mt-6" />
      </Card>
    </div>
  </Card>
</template>
